function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.333h512V426.67H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M115.71 117.564c-13.831 0-25.452 9.46-28.747 22.261l28.747 7.421 28.747-7.421c-3.295-12.803-14.917-22.261-28.747-22.261z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M86.029 184.346l37.101 7.421v-15.776c10.429-2.686 18.639-10.897 21.324-21.326l-28.744-7.421H78.609l7.421 22.261v14.841z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M144.456 139.824H78.609v29.68h7.421v-14.84h58.426a29.848 29.848 0 000-14.84z",
  fill: "#acabb1"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M403.71 117.564c-13.831 0-25.452 9.46-28.747 22.261l28.747 7.421 28.747-7.421c-3.295-12.803-14.917-22.261-28.747-22.261z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M374.029 184.346l37.101 7.421v-15.776c10.429-2.686 18.639-10.897 21.324-21.326l-28.744-7.421h-37.101l7.421 22.261-.001 14.841z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M432.456 139.824h-65.848v29.68h7.421v-14.84h58.426c.611-2.372.937-4.858.937-7.421a29.8 29.8 0 00-.936-7.419z",
  fill: "#acabb1"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M403.71 320.226c-13.831 0-25.452 9.46-28.747 22.261l28.747 7.421 28.747-7.421c-3.295-12.802-14.917-22.261-28.747-22.261z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M374.029 387.009l37.101 7.421v-15.776c10.429-2.686 18.639-10.897 21.324-21.326l-28.744-7.421h-37.101l7.421 22.261-.001 14.841z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M432.456 342.487h-65.848v29.68h7.421v-14.84h58.426c.611-2.372.937-4.858.937-7.421a29.8 29.8 0 00-.936-7.419z",
  fill: "#acabb1"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M115.71 320.226c-13.831 0-25.452 9.46-28.747 22.261l28.747 7.421 28.747-7.421c-3.295-12.802-14.917-22.261-28.747-22.261z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M86.029 387.009l37.101 7.421v-15.776c10.429-2.686 18.639-10.897 21.324-21.326l-28.744-7.421H78.609l7.421 22.261v14.841z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M144.456 342.487H78.609v29.68h7.421v-14.84h58.426a29.848 29.848 0 000-14.84z",
  fill: "#acabb1"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"
});

const SvgSardinia = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSardinia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sardinia.8f1b4287.svg";
export { ForwardRef as ReactComponent };